var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef, memo } from "react";
const SvgDelete32 = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 33,
  height: 32,
  fill: "none",
  viewBox: "0 0 33 32",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF453A",
  fillRule: "evenodd",
  d: "M14.015 6.108a.246.246 0 0 0-.246.246V8.06h6.185V6.354a.246.246 0 0 0-.246-.246zm7.44 1.952V6.354c0-.964-.783-1.746-1.747-1.746h-5.693c-.964 0-1.746.782-1.746 1.746V8.06H6.792a.75.75 0 0 0 0 1.5h1.54l.97 14.8a2.74 2.74 0 0 0 2.737 2.563h9.36a2.743 2.743 0 0 0 2.738-2.563l.97-14.8h1.54a.75.75 0 1 0 0-1.5h-5.192m-.75 1.5H9.834l.964 14.702a1.24 1.24 0 0 0 1.24 1.161h9.36c.656 0 1.198-.508 1.24-1.161l.965-14.702zm-6.68 3.34a.75.75 0 0 1 .802.695l.57 7.97a.75.75 0 0 1-1.497.107l-.57-7.97a.75.75 0 0 1 .695-.802m6.04.802a.75.75 0 0 0-1.497-.107l-.57 7.97a.75.75 0 0 0 1.497.107z",
  clipRule: "evenodd"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgDelete32);
const Memo = /*#__PURE__*/memo(ForwardRef);
export { Memo as ReactComponent };